import L from 'leaflet';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import './ConfirmationPopup.css';

@inject("appStore")
@observer
class ConfirmationPopup extends Component {
    componentDidMount = () => {
        //TEMP L.DomEvent.disableClickPropagation(this.wrapperDOMref);

    };
    handleCancel = () => {
        if (!this.props.appStore.pendingState.editing){
            this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        }
        this.props.appStore.clearPending();
    };
    render() {
        return (
            <div className="ConfirmationPopup" ref={ref => this.wrapperDOMref = ref}>
                <h3>
                    <FontAwesomeIcon className="infoIcon" icon={ faInfoCircle } size="lg"  />
                    {!this.props.drawStarted && this.props.defaultMessage}
                    {this.props.drawStarted && this.props.alternativeMessage}
                </h3>
                <div className="buttons">
                    <button className="cancel" onClick={this.handleCancel}>
                        {intl.get("ConfirmationPopup.cancel")}
                    </button>
                    <button className="done" disabled={!this.props.appStore.allowSave} onClick={this.props.handleDone}>
                    {/*<button className={"done " + (!this.props.appStore.allowSave ? "disabled" : "")} aria-label="Done" disabled={!this.props.appStore.allowSave} onClick={this.props.handleDone}>*/}
                        {intl.get("ConfirmationPopup.done")}
                    </button>
                </div>
            </div>
        );
    }
}

export default ConfirmationPopup;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/ConfirmationPopup/index.js